import { InfoOutlined } from '@mui/icons-material';
import {
	Autocomplete,
	Chip,
	Typography,
	AutocompleteRenderInputParams,
	TextField,
	InputAdornment,
	IconButton,
	Stack,
} from '@mui/material';

import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { Controller } from 'react-hook-form';

import { setToastMessage } from 'common/store/reducer/commonReducer';

import { ReactComponent as DrawerClose } from '../../../common/assets/images/drawer-close.svg';

import styles from './AddUser/CreateUser.module.scss';

const { whiteBackground, chipBackground, whiteText, borderColor } = styles;

interface IGroupListProps {
	data: any;
	type: string;
	onDelete: (e: any) => void;
	control: any;
	selectedGroups: any;
}
const GroupsList = (props: IGroupListProps) => {
	const dispatch = useDispatch();
	const [, setIsToastOpen] = useState(false);
	const { data, type, onDelete, control, selectedGroups } = props;
	const onChipDelete = (option: any) => {
		onDelete(option);

		if (selectedGroups.length <= 1) {
			setIsToastOpen(true);
			dispatch(
				setToastMessage({
					message: 'The user should have atleast one group',
					severity: 'warning',
					isToastOpen: true,
				}),
			);
		}
	};
	const toastWarningHandler = () => {
		if (selectedGroups.length <= 1) {
			setIsToastOpen(true);
			dispatch(
				setToastMessage({
					message: 'The user should have atleast one group',
					severity: 'warning',
					isToastOpen: true,
				}),
			);
		}
	};

	const { drawerCloseIconColor } = styles;

	return (
		<Controller
			name={type}
			control={control}
			render={({ field }) => (
				<Autocomplete
					id="tags-filled"
					data-testid="groups-list"
					componentsProps={{
						paper: {
							sx: {
								width: 476,
							},
						},
					}}
					key={`${type}+select`}
					multiple
					size="small"
					className={styles['search-field-size']}
					sx={{
						width: { sm: '100%', md: '100%' },
						'& .MuiOutlinedInput-root': {
							paddingRight: '10px !important',
							backgroundColor: whiteBackground,
						},
						'& + .MuiAutocomplete-popper .MuiAutocomplete-option': {
							backgroundColor: whiteBackground,
							borderBottom: `1px solid ${borderColor}`,
						},
						"& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']":
							{
								backgroundColor: whiteBackground,
							},
						'& + .MuiAutocomplete-popper .MuiAutocomplete-option:hover': {
							backgroundColor: whiteBackground,
						},
						"& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']:hover":
							{
								backgroundColor: whiteBackground,
							},
					}}
					options={data}
					getOptionLabel={(option: any) => option?.groupName || null}
					renderTags={(value, getTagProps) =>
						value.map((option: any, index) => (
							<div key={`${type}+${option.groupName}`}>
								<Chip
									variant="outlined"
									deleteIcon={
										<IconButton
											data-testid="chip-delete"
											onClick={toastWarningHandler}
										>
											<DrawerClose fill={drawerCloseIconColor} />
										</IconButton>
									}
									{...getTagProps({ index })}
									sx={{
										color: whiteText,
										borderRadius: 15,
										height: 29,
										backgroundColor: chipBackground,
										'& .MuiChip-deleteIcon': {
											color: whiteText,
											fontSize: 12,
										},
										'& .MuiChip-root': {
											borderRadius: 1,
										},
									}}
									label={option?.groupName}
								/>
							</div>
						))
					}
					renderOption={(props: object, option: any) => (
						<div
							data-testid={option.groupName}
							{...props}
							key={option?.groupId}
						>
							<Stack
								direction="column"
								className={styles['user-column']}
								alignItems="start"
								data-testid={option.groupName}
							>
								<Typography className={styles['user-name-column']}>
									{option?.groupName}
								</Typography>
							</Stack>
						</div>
					)}
					renderInput={(params: AutocompleteRenderInputParams) => (
						<TextField
							key="groups"
							name="groups"
							{...params}
							sx={{
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										border: `1px solid ${borderColor}`,
										borderRadius: '5px',
									},
									'&.Mui-focused fieldset': {
										border: `1px solid ${borderColor}`,
										borderRadius: '5px',
									},
								},
							}}
							InputProps={{
								...params.InputProps,
								tabIndex: 4,
								type: 'search',
								endAdornment: (
									<InputAdornment position="end">
										{type === 'email' ? (
											<InfoOutlined className={styles['icon-size']} />
										) : null}
									</InputAdornment>
								),
							}}
						/>
					)}
					{...field}
					onChange={(_e, data: any[], situation, option: any) => {
						field.onChange(data);
						if (situation === 'removeOption') {
							onChipDelete(option);
						}
					}}
					isOptionEqualToValue={(option: any, value: any) =>
						value === undefined ||
						value === '' ||
						value === null ||
						option.groupName === value.groupName
					}
				/>
			)}
		/>
	);
};
export default GroupsList;
